import { RefObject, useEffect, useRef } from "react";
import type { ChatInputHandle } from "../components/ChatInput";

interface UseInitialPromptArgs {
  initialPrompt: string | undefined;
  autoSend: boolean | undefined;
  agentOnlyContext: string | undefined;
  conversationId: string | undefined;
  isConversationLoading: boolean;
  sendMessage: (message: string, selectedSkills?: string[], options?: { agentOnlyContext?: string }) => void;
  chatInput: RefObject<ChatInputHandle | null>;
}

export function useInitialPrompt({
  initialPrompt,
  autoSend,
  agentOnlyContext,
  conversationId,
  isConversationLoading,
  sendMessage,
  chatInput,
}: UseInitialPromptArgs) {
  const autoSentRequestRef = useRef<string | null>(null);
  const insertedInitialPromptRef = useRef<string | null>(null);
  useEffect(() => {
    if (!initialPrompt) return;

    if (autoSend) {
      if (!conversationId || isConversationLoading) return;
      const autoSendRequestKey = JSON.stringify({
        initialPrompt,
        agentOnlyContext: agentOnlyContext ?? "",
      });
      if (autoSentRequestRef.current === autoSendRequestKey) return;
      autoSentRequestRef.current = autoSendRequestKey;
      sendMessage(initialPrompt, undefined, { agentOnlyContext });
      return;
    }

    if (chatInput.current && insertedInitialPromptRef.current !== initialPrompt) {
      insertedInitialPromptRef.current = initialPrompt;
      chatInput.current.insertValue(initialPrompt);
      chatInput.current.focus();
    }
  }, [
    initialPrompt,
    autoSend,
    agentOnlyContext,
    conversationId,
    isConversationLoading,
    sendMessage,
  ]);
}
